import { newToolFilterOAuthMcp } from "../oauth.ts";

export const luminMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.luminpdf.com/favicon/lumin/lumin.svg",
  url: "https://mcp.luminpdf.com/mcp",
  label: "Lumin",
});
